import { AnyAction } from "redux";
import {
  FETCH_CART_FAILURE,
  FETCH_CART_REQUEST,
  FETCH_CART_RESET,
  FETCH_CART_SUCCESS,
  REMOVE_CART_REQUEST,
  REMOVE_CART_SUCCESS,
  REMOVE_CART_FAILURE,
  CREATE_CART_REQUEST,
  CREATE_CART_SUCCESS,
  CREATE_CART_FAILURE,
  UPDATE_CART_QUANTITY_REQUEST,
  UPDATE_CART_QUANTITY_SUCCESS,
  UPDATE_CART_QUANTITY_FAILURE,
} from "../actions/cartAction";
import { CartState } from "../types/cartTypes";

const initialState: CartState = {
  cartData: {
    products: [],
    carts: [],
    totalRecords: 0,
  },
  loading: false,
  error: null,
};

const cartReducer = (state = initialState, action: AnyAction): CartState => {
  switch (action.type) {
    case FETCH_CART_REQUEST:
    case REMOVE_CART_REQUEST:
    case CREATE_CART_REQUEST:
    case UPDATE_CART_QUANTITY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CART_SUCCESS:
      // Always replace with payload data to ensure state is in sync
      return {
        ...state,
        cartData: {
          products: action.payload.products || [],
          carts: action.payload.carts || [],
          totalRecords:
            action.payload.totalRecords ?? state.cartData.totalRecords,
        },
        loading: false,
        error: null,
      };
    case REMOVE_CART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case CREATE_CART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case UPDATE_CART_QUANTITY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case FETCH_CART_FAILURE:
    case REMOVE_CART_FAILURE:
    case CREATE_CART_FAILURE:
    case UPDATE_CART_QUANTITY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_CART_RESET:
      return {
        ...state,
        cartData: {
          products: [],
          carts: [],
          totalRecords: 0,
        },
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export default cartReducer;
